import React from "react";
import { Chip } from "@mui/material";

const CRMBadge = ({ label, bg = "#e5e7eb", text = "#374151", size = "small" }) => (
    <Chip
        label={label}
        size={size}
        sx={{
            backgroundColor: bg,
            color: text,
            fontWeight: 700,
            fontSize: "0.68rem",
            letterSpacing: "0.04em",
            textTransform: "uppercase",
            height: 22,
            borderRadius: "999px",
            "& .MuiChip-label": { px: 1.25 },
        }}
    />
);

export default CRMBadge;
